module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of title.",
      "src": "image/NDD_title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Book-Title-2"
  }, [_vm._v("Desserts")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Book-Subtitle"
  }, [_c('span', {
    staticClass: "_00-subtile _idGenCharOverride-1"
  }, [_vm._v("100")]), _vm._v(" Sweet\n\t\t\t\tbut Not Sinful Treats")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "author"
  }, [_vm._v("Danny Seo")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "after-author"
  }, [_vm._v("From the kitchens of "), _c('em', {
    staticClass: "medium-italic _idGenCharOverride-1"
  }, [_vm._v("Naturally, Danny Seo")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "Photo of logo.",
      "src": "image/logo.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "CIP"
  }, [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Text © 2020 Danny Seo")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Photography credits noted throughout.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced by any means\n\t\t\t\twhatsoever without written permission from the publisher, except brief portions\n\t\t\t\tquoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("1.800.835.4993 orders")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gibbs-smith.com",
      "target": "_blank"
    }
  }, [_vm._v("www.gibbs-smith.com")])]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Library of Congress Control Number: 2020933150")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("ISBN: 978-1-4236-5538-1 (ebook)")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("To Kerry. You’re the sweetest thing. ")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Contents-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors#_idTextAnchor000"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors1#_idTextAnchor001"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor002"
    }
  }, [_vm._v("Just\n\t\t\t\t\tCookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor003"
    }
  }, [_vm._v("The Famous\n\t\t\t\t\tFriday Chocolate Chip Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor004"
    }
  }, [_vm._v("Lemon-Scented Hemp Seed Lace Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor005"
    }
  }, [_vm._v("Black and\n\t\t\t\t\tWhite Sesame Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor006"
    }
  }, [_vm._v("Dark\n\t\t\t\t\tChocolate–Ginger Macaroons")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor007"
    }
  }, [_vm._v("Miniature\n\t\t\t\t\tPink Raspberry Meringues ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor008"
    }
  }, [_vm._v("Red,\n\t\t\t\t\tWhite, And Blue Coconut Macaroons")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor009"
    }
  }, [_vm._v("Parsnip\n\t\t\t\t\tOatmeal Raisin Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor010"
    }
  }, [_vm._v("Ready-To-Eat Maple Chocolate Chip Cookie Dough")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor011"
    }
  }, [_vm._v("Almond\n\t\t\t\t\tButter Gingersnap Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor012"
    }
  }, [_vm._v("Holiday\n\t\t\t\t\tPaleo Thin Mints")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor013"
    }
  }, [_vm._v("Ice Box\n\t\t\t\t\tMaple Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor014"
    }
  }, [_vm._v("Flourless\n\t\t\t\t\tSpiced Gingerbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor015"
    }
  }, [_vm._v("Chewy\n\t\t\t\t\tCauliflower—Black Sesame Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor016"
    }
  }, [_vm._v("Parsnip—Brown Butter Sugar Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor017"
    }
  }, [_vm._v("Beet,\n\t\t\t\t\tAquafaba, and Rose Macarons")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor018"
    }
  }, [_vm._v("Gluten-Free Zucchini Muesli Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor019"
    }
  }, [_vm._v("Vegetable\n\t\t\t\t\tJuice Fortune-Shaped Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor020"
    }
  }, [_vm._v("Spinach—Peppermint Crème Whoopie Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor021"
    }
  }, [_vm._v("Root\n\t\t\t\t\tVegetable Fun-fetti Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor022"
    }
  }, [_vm._v("Paleo\n\t\t\t\t\tSweet Potato—Cinnamon Crunch Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor023"
    }
  }, [_vm._v("Black\n\t\t\t\t\tCocoa “Oreos” with Cauliflower Crème")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor024"
    }
  }, [_vm._v("Chewy\n\t\t\t\t\tChocolate-Avocado Protein Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor025"
    }
  }, [_vm._v("Avocado\n\t\t\t\t\tBoston Cream Pie Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors2#_idTextAnchor026"
    }
  }, [_vm._v("Matcha-Dusted Gluten-Free Almond Biscotti")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor027"
    }
  }, [_vm._v("Chill\n\t\t\t\t\tOut")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor028"
    }
  }, [_vm._v("Creamsicle\n\t\t\t\t\tCashew “Cheesecake”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor029"
    }
  }, [_vm._v("Raspberry\n\t\t\t\t\tTiramisu Parfait")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor030"
    }
  }, [_vm._v("Frozen\n\t\t\t\t\tWinter-Citrus Sherbet")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor031"
    }
  }, [_vm._v("Vegan\n\t\t\t\t\tApple-Hibiscus Jelly-O Gelatin")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor032"
    }
  }, [_vm._v("Vegan\n\t\t\t\t\tPineapple-Turmeric Jelly-O Gelatin")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor033"
    }
  }, [_vm._v("Vegan\n\t\t\t\t\tCoconut-Chia Jelly-O Gelatin")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor034"
    }
  }, [_vm._v("Vegan\n\t\t\t\t\tBlackberry-Jasmine Jelly-O Gelatin ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor035"
    }
  }, [_vm._v("Vegetarian\n\t\t\t\t\tGrapefruit-Honey Jelly-O Gelatin")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor036"
    }
  }, [_vm._v("Raspberry-Lemon Swirl Frozen “Cheesecake” Pops")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor037"
    }
  }, [_vm._v("Turmeric\n\t\t\t\t\tand Maple Golden Gelato")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor038"
    }
  }, [_vm._v("Maca\n\t\t\t\t\tHoneycomb Frozen Yogurt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor039"
    }
  }, [_vm._v("Maca,\n\t\t\t\t\tFrozen Banana, and Toasted Coconut “Milkshake”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor040"
    }
  }, [_vm._v("Summer\n\t\t\t\t\tPeach and Avocado Swirl Popsicles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor041"
    }
  }, [_vm._v("Avocado,\n\t\t\t\t\tCoconut, and Lime Sherbet")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor042"
    }
  }, [_vm._v("Matcha-Gato: Matcha Shot with Churned Vanilla “Ice Cream”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor043"
    }
  }, [_vm._v("Frozen\n\t\t\t\t\tMatcha Mousse Tart")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors3#_idTextAnchor044"
    }
  }, [_vm._v("Bullet-Proof Coffee Coconut Popsicles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor045"
    }
  }, [_vm._v("Dough\n\t\t\t\t\tBoy")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor046"
    }
  }, [_vm._v("Luscious\n\t\t\t\t\tBanana Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor047"
    }
  }, [_vm._v("Flourless\n\t\t\t\t\tToasted Almond Torte with Almond Gelato")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor048"
    }
  }, [_vm._v("Dark\n\t\t\t\t\tChocolate Beet Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor049"
    }
  }, [_vm._v("Sweet Pea\n\t\t\t\t\tCupcakes with White Chocolate Frosting")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor050"
    }
  }, [_vm._v("Golden\n\t\t\t\t\tBeet and Cinnamon Coffee Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor051"
    }
  }, [_vm._v("Pineapple\n\t\t\t\t\tStrudel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor052"
    }
  }, [_vm._v("Edible\n\t\t\t\t\tPetal Confetti Fun-fetti Birthday Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor053"
    }
  }, [_vm._v("Baked\n\t\t\t\t\tMiniature Donuts with Spirulina Sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor054"
    }
  }, [_vm._v("Gluten-Free Coffee Tres Leche Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor055"
    }
  }, [_vm._v("Coffee\n\t\t\t\t\tCrepe-Layer Cake with Mocha Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor056"
    }
  }, [_vm._v("Matcha\n\t\t\t\t\tGluten-Free Blondie Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor057"
    }
  }, [_vm._v("Orange-Quinoa Olive Oil Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor058"
    }
  }, [_vm._v("Chocolate\n\t\t\t\t\tQuinoa Cake with Marshmallow Frosting")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor059"
    }
  }, [_vm._v("Paleo\n\t\t\t\t\tSweet Potato Monkey Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor060"
    }
  }, [_vm._v("Mini Paleo\n\t\t\t\t\tCinnamon-Walnut Sticky Buns")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors4#_idTextAnchor061"
    }
  }, [_vm._v("Pistachio-Cardamom Baklava Strudel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor062"
    }
  }, [_vm._v("A Sweet\n\t\t\t\t\tStart")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor063"
    }
  }, [_vm._v("Almost-Milkshake with Hemp and Hazelnut")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor064"
    }
  }, [_vm._v("Crunchy-Good Cardamom Granola ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor065"
    }
  }, [_vm._v("Breakfast\n\t\t\t\t\tCookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor066"
    }
  }, [_vm._v("Banana-Pecan Overnight Oats")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor067"
    }
  }, [_vm._v("Yogurt\n\t\t\t\t\tBowl with Brûléed Bananas and Mint")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor068"
    }
  }, [_vm._v("Sweet\n\t\t\t\t\tPotato-Peach Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor069"
    }
  }, [_vm._v("Peanut\n\t\t\t\t\tButter Poppers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor070"
    }
  }, [_vm._v("Pumpkin\n\t\t\t\t\tWaffles ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor071"
    }
  }, [_vm._v("Carrot\n\t\t\t\t\tCake Pancake Stack with Raisin Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor072"
    }
  }, [_vm._v("Golden\n\t\t\t\t\tTurmeric Oats with Crushed Pistachios and Rose Water")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor073"
    }
  }, [_vm._v("Breakfast\n\t\t\t\t\tPoke Bowl")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor074"
    }
  }, [_vm._v("Flavored\n\t\t\t\t\tAlmond Milk ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor075"
    }
  }, [_vm._v("Cherry,\n\t\t\t\t\tAvocado, and Pistachio Granola Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor076"
    }
  }, [_vm._v("Coffee\n\t\t\t\t\tSmoothie ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors5#_idTextAnchor077"
    }
  }, [_vm._v("Raspberry,\n\t\t\t\t\tChocolate, and Almond Cereal Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor078"
    }
  }, [_vm._v("The\n\t\t\t\t\tChocolate Factory")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor079"
    }
  }, [_vm._v("The\n\t\t\t\t\tEverything Chocolate Bark")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor080"
    }
  }, [_vm._v("Party-Perfect Chocolate and Coconut Truffles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor081"
    }
  }, [_vm._v("Cacao-Mulberry Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor082"
    }
  }, [_vm._v("White\n\t\t\t\t\tChocolate and Matcha Microwave Popcorn")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor083"
    }
  }, [_vm._v("Dark\n\t\t\t\t\tChocolate Truffles with Black Lava Rock Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor084"
    }
  }, [_vm._v("Eggplant\n\t\t\t\t\tFudge Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor085"
    }
  }, [_vm._v("Black\n\t\t\t\t\tForest-Avocado Mousse with Macerated Cherries and Cacao Nibs")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor086"
    }
  }, [_vm._v("Dark\n\t\t\t\t\tChocolate Matcha Nut Butter Cups")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor087"
    }
  }, [_vm._v("Winter\n\t\t\t\t\tMatcha Peppermint Patties")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor088"
    }
  }, [_vm._v("Almond\n\t\t\t\t\tFlour “Twix”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor089"
    }
  }, [_vm._v("Keto White\n\t\t\t\t\tChocolate-Macadamia Fudge")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors6#_idTextAnchor090"
    }
  }, [_vm._v("Dark\n\t\t\t\t\tChocolate Avocado Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor091"
    }
  }, [_vm._v("Sweet\n\t\t\t\t\tUn-Nothings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor092"
    }
  }, [_vm._v("Maca and\n\t\t\t\t\tToasted Almond Fudge")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor093"
    }
  }, [_vm._v("Brown Rice\n\t\t\t\t\tCrispy Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor094"
    }
  }, [_vm._v("Summer\n\t\t\t\t\tFruit Jerky")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor095"
    }
  }, [_vm._v("Toasted\n\t\t\t\t\tBlack Sesame Brittle")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor096"
    }
  }, [_vm._v("Viola\n\t\t\t\t\tBlossom Honey Lollipops")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor097"
    }
  }, [_vm._v("Herb\n\t\t\t\t\tBlossom Speckled Matcha and White Chocolate Bark")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor098"
    }
  }, [_vm._v("Aquafaba\n\t\t\t\t\tMarshmallow Fluff")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor099"
    }
  }, [_vm._v("Avocado\n\t\t\t\t\tMatcha Crème Brûlée")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor100"
    }
  }, [_vm._v("Sweet\n\t\t\t\t\tMatcha Mango Sticky Rice Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor101"
    }
  }, [_vm._v("Homemade\n\t\t\t\t\tMatcha Collagen Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor102"
    }
  }, [_vm._v("No-Bake\n\t\t\t\t\tCoconut-Lime Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor103"
    }
  }, [_vm._v("Miso-Caramel Popcorn")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor104"
    }
  }, [_vm._v("Purple\n\t\t\t\t\tSweet Potato Pie Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor105"
    }
  }, [_vm._v("Oversized\n\t\t\t\t\tBlue Spirulina Marshmallows")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Naturally_Delicious_Desserts_Interiors7#_idTextAnchor106"
    }
  }, [_vm._v("Sticky\n\t\t\t\t\tToffee Baked Oatmeal")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('h1', {
    staticClass: "Front-head-A",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "Normal-no-indent"
  }, [_c('strong', {
    staticClass: "Strong _idGenCharOverride-2"
  }, [_vm._v("It sure takes a village to make a book\n\t\t\t\t\tand this is no exception.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Of course, a big dose of gratitude goes to Gibbs Smith and my editor\n\t\t\t\tMichelle Branson who had the brilliant idea to turn my love of desserts with a\n\t\t\t\thealthy twist into a book.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("My agent I’ve worked with for as long as I can remember—Joy Tutela—who\n\t\t\t\thas been a guide, a friend and—like the Golden Girls jingle says—a confidant. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The hardworking photographers who contributed to this book: Alexandra\n\t\t\t\tGrablewski, Rikki Snyder, David Engelhardt, Armando Rafael, and Shelly Strazis. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("In my earlier life, I was a prop stylist, so I can appreciate what it\n\t\t\t\ttakes to turn a simple recipe into a work-of-art in photos. Here’s a big cheer to\n\t\t\t\tthe stylists who worked on these images: Maeve Sheridan, Kristine Trevino, Nidia\n\t\t\t\tCuevo, Corey Belle, Eugene Jho, and Leslie Orlandi.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Plus everyone at the magazine who help churn out one issue after\n\t\t\t\tanother (and each time better!): Sandy Soria, Alexis Cook, Mike Wilson, and all the\n\t\t\t\tcontributing writers and everyone at RFP Corp who help behind the scenes. And to all\n\t\t\t\tthe brand partners who have supported us from the start and continue to do so today,\n\t\t\t\tthank you soooo much. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("And finally, a big thank you to all the viewers and readers. It’s one\n\t\t\t\tthing to create a beautiful product, but it’s only worth it when it inspires and\n\t\t\t\texcites people like you. I do this for you. Cheers! ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "Photo of citrus fruit.",
      "src": "image/079_Aikm_9781607747673_art_r1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Photograph by Victoria Pearson")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f40ff6b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Naturally_Delicious_Desserts_Interiors.vue
// module id = 60
// module chunks = 0